import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';

function DiwasaRouter() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/product1/dashboard" replace />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="*" element={<Navigate to="/product1/dashboard" replace />} />
    </Routes>
  );
}

export default DiwasaRouter;
